export function isfunc(f) {
    return typeof f === 'function';
}
export function createEmptyModule(meta) {
    return Object.assign(Object.assign({}, meta), { setup() { } });
}
export function getBasePath(link) {
    if (link) {
        const idx = link.lastIndexOf('/');
        return link.substr(0, idx + 1);
    }
    return link;
}
export function setBasePath(meta, link) {
    meta.basePath = getBasePath(link);
    return link;
}
//# sourceMappingURL=utils.js.map